/* global axios */

export default {
  create({ accountId, conversationId, messageId, emoji }) {
    return axios.post(
      `/api/v1/accounts/${accountId}/conversations/${conversationId}/messages/${messageId}/react`,
      { emoji }
    );
  },
};
